import { createContext } from 'react';

import type { GroupSubscriptionData } from '@shared/dream-components';

import type { Subscription } from '~/interfaces/subscriptions';
import type { GeneralScenarioKey } from '~/routes/subscribe/$subscriberId/_components/v2/hooks/generalScenarios';

export type DevScenarioContextType = {
  /** Active dev scenario key. Always `'live'` in production — the pickers are DEV-gated. */
  scenario: GeneralScenarioKey;
  setScenario: (scenario: GeneralScenarioKey) => void;
  /** Subscription with the active scenario applied; identity passthrough on `'live'`. */
  effectiveSubscription: Subscription;
  /**
   * Apply the active scenario to a group-subscriptions list. Centralizes scenario
   * application here (alongside `effectiveSubscription`) so consumers like
   * GroupSubscriptionsProvider don't reach into the scenario util directly.
   */
  applyGroupScenario: (groups: GroupSubscriptionData[]) => GroupSubscriptionData[];
};

export const DevScenarioContext = createContext<DevScenarioContextType | undefined>(undefined);
DevScenarioContext.displayName = 'DevScenarioContext';
